export enum CountryIso31661Alpha2Code {
    SWITZERLAND = 'CH',
    GERMANY = 'DE',
}
